import { getGlobalSetApi2, ApiGetAirportsList } from '@/apis/home';
import type { PsgTypeWithNumItem } from '@/logic/home/model';
// 热门城市接口调用
export const getHotCityData = async (lang: string, currency: string) => {
    let res = await getGlobalSetApi2({ lang, currency });
    return res;
};

// 搜索城市接口调用
export const getAirportsList = async (lang: string, keys: string) => {
    const res = await ApiGetAirportsList({ lang, keys });
    return res;
};
// 将日期中的横线去掉
export const removeDashesFromDate = (dateStr: string) => {
    return dateStr.replace(/-/g, '');
};

export const calculatePsgNumEnable = (passengerList: PsgTypeWithNumItem[], passengerType: number, addType: number, ticketType: string, count: number) => {
    //按乘客类型划分，第一步筛选乘客类型，第二步筛选加减（加需满足和小于9，减需大于零，成人在一般情况下至少一个）
    //每种case增加简单注释，解释其中逻辑
    switch (passengerType) {
        case 0:
            return ['1', '2'].indexOf(ticketType) > -1 && ((addType === 1 && count < 9) || (addType === 0 && passengerList[0].actNum > 1));
        case 1:
            return (
                ticketType === '1' &&
                ((addType === 1 && count < 9 && passengerList[1].actNum + passengerList[2].actNum < passengerList[0].actNum * 2) ||
                    (addType === 0 && passengerList[1].actNum > 0))
            );
        case 2:
            return (
                ticketType === '1' &&
                ((addType === 1 &&
                    count < 9 &&
                    passengerList[0].actNum * 2 > passengerList[1].actNum + passengerList[2].actNum &&
                    passengerList[2].actNum < passengerList[0].actNum) ||
                    (addType === 0 && passengerList[2].actNum > 0))
            );
        case 3:
            return ticketType === '2' && ((addType === 1 && count < 9) || (addType === 0 && passengerList[3].actNum > 0));
        case 4:
            return ticketType === '3' && ((addType === 1 && count < 9) || (addType === 0 && passengerList[4].actNum > 0));
        case 5:
            return ticketType === '4' && ((addType === 1 && count < 9) || (addType === 0 && passengerList[5].actNum > 0));
    }
};

export const changePsgNum = (psgType: string, psgList: PsgTypeWithNumItem[], changeNum: number) => {
    switch (psgType) {
        case 'adult':
            psgList[0].actNum = psgList[0].actNum + changeNum;
            if (changeNum === -1) {
                if (psgList[2].actNum > psgList[0].actNum) {
                    psgList[2].actNum = psgList[0].actNum;
                }
                if (psgList[1].actNum > 0) {
                    if (psgList[2].actNum + psgList[1].actNum > psgList[0].actNum * 2) {
                        psgList[1].actNum = psgList[1].actNum - 1;
                        if (psgList[2].actNum + psgList[1].actNum > psgList[0].actNum * 2) {
                            psgList[1].actNum = psgList[1].actNum - 1;
                        }
                    }
                }
            }
            break;
        case 'child':
            psgList[1].actNum = psgList[1].actNum + changeNum;
            break;
        case 'infant':
            psgList[2].actNum = psgList[2].actNum + changeNum;
            break;
        case 'student':
            psgList[3].actNum = psgList[3].actNum + changeNum;
            break;
        case 'helper':
            psgList[4].actNum = psgList[4].actNum + changeNum;
            break;
        case 'seamen':
            psgList[5].actNum = psgList[5].actNum + changeNum;
            break;
    }
    const count: number = psgList.reduce((acc: number, item: any) => {
        return acc + item.actNum;
    }, 0);
    return { list: psgList, count: count };
};




















































export const addPsgNum = (type: number, tempPsg: PsgTypeWithNumItem[]) => {
    switch (type) {
        case 0:
            tempPsg[0].actNum = tempPsg[0].actNum + 1;
            break;
        case 1:
            tempPsg[1].actNum = tempPsg[1].actNum + 1;
            break;
        case 2:
            tempPsg[2].actNum = tempPsg[2].actNum + 1;
            break;
        case 3:
            tempPsg[3].actNum = tempPsg[3].actNum + 1;
            break;
        case 4:
            tempPsg[4].actNum = tempPsg[4].actNum + 1;
            break;
        case 5:
            tempPsg[5].actNum = tempPsg[5].actNum + 1;
            break;
    }
    const count: number = tempPsg.reduce((acc: number, item: any) => {
        return acc + item.actNum;
    }, 0);
    return { list: tempPsg, count: count };
};

export const minusPsgNum = (type: number, tempPsg: PsgTypeWithNumItem[]) => {
    switch (type) {
        case 0:
            tempPsg[0].actNum = tempPsg[0].actNum - 1;
            if (tempPsg[2].actNum > tempPsg[0].actNum) {
                tempPsg[2].actNum = tempPsg[0].actNum;
            }
            if (tempPsg[1].actNum > 0) {
                if (tempPsg[2].actNum + tempPsg[1].actNum > tempPsg[0].actNum * 2) {
                    tempPsg[1].actNum = tempPsg[1].actNum - 1;
                    if (tempPsg[2].actNum + tempPsg[1].actNum > tempPsg[0].actNum * 2) {
                        tempPsg[1].actNum = tempPsg[1].actNum - 1;
                    }
                }
            }
            break;
        case 1:
            tempPsg[1].actNum = tempPsg[1].actNum - 1;
            break;
        case 2:
            tempPsg[2].actNum = tempPsg[2].actNum - 1;
            break;
        case 3:
            tempPsg[3].actNum = tempPsg[3].actNum - 1;
            break;
        case 4:
            tempPsg[4].actNum = tempPsg[4].actNum - 1;
            break;
        case 5:
            tempPsg[5].actNum = tempPsg[5].actNum - 1;
            break;
    }
    let count: number = tempPsg.reduce((acc: number, item: any) => {
        return acc + item.actNum;
    }, 0);
    return { list: tempPsg, count: count };
};